import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useAuth, AuthProvider } from "./authContext";
import Login from "../views/Authentication/Login";
import Layout from "../views/layout/Layout";
import Homepage from "../views/Homepage";
import AllApplications from "../views/Inbox/AllApplications";
import EditForms from "../views/Onboarding/EditForms";
import CreateForm from "../views/Onboarding/CreateForm";
import FileLibrary from "../views/Onboarding/FileLibrary";
import Candidate from "../views/candidate/CandidateView";
import CandidateOnboardingForm from "../views/Onboarding/CandidateOnboardingForm";
import ConvertDocument from "../views/Onboarding/ConvertDocument";
import DocumentUpload from "../views/Onboarding/DocumentUpload";
import EditDocument from "../views/Onboarding/EditDocument";
import FillCandidate from "../views/Onboarding/FillCandidate";
import WelcomePage from "../views/candidateverification/WelcomePage";
import OtpVerification from "../views/candidateverification/OtpVerification";
import ThankYou from "../views/candidateverification/ThankYou";
import Resources from "../views/Onboarding/resources";
import ResourceView from "../views/Onboarding/resourceView";
import DownloadView from "../views/Onboarding/DownloadView";
import Everify from "../views/Onboarding/Everify";
import ContinueCase from "../views/Onboarding/ContinueCase";
import Templates from "../views/Onboarding/Templates";
import OnboardingTemplates from "../views/Onboarding/OnboardingTemplates";
import NewOnboardingTemplate from "../views/Onboarding/newOnboardingTemplate";
import RedirectI9Form from "../views/legalforms/RedirectI9Form";

const PrivateRoutes = () => {
  const { isAuthenticated } = useAuth();
  console.log(isAuthenticated);
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

const Routing = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route element={<PrivateRoutes />}>
          <Route path="dashboard" element={<Layout />}>
            <Route index element={<Homepage />} />
            <Route path="candidates" element={<AllApplications />} />
            <Route path="onboarding/edit-forms" element={<EditForms />} />
            <Route path="onboarding/create-form" element={<CreateForm />} />
            <Route path="onboarding/edit-form" element={<CreateForm />} />
            <Route
              path="onboarding/edit-candidate-form"
              element={<CreateForm />}
            />
            <Route path="onboarding/edit-template" element={<CreateForm />} />
            <Route path="onboarding/copy-template" element={<CreateForm />} />
            <Route
              path="onboarding/edit-onboarding-template-form"
              element={<CreateForm />}
            />
            <Route
              path="onboarding/create-onboarding-template-form"
              element={<CreateForm />}
            />
            <Route path="onboarding/file-library" element={<FileLibrary />} />
            <Route path="convertdocuments" element={<ConvertDocument />} />
            <Route path="upload" element={<DocumentUpload />} />
            <Route path="resources" element={<Resources />} />
            <Route path="resource-view" element={<ResourceView />} />
            <Route path="everify" element={<Everify />} />
            <Route path="review/:id/:caseId" element={<ContinueCase />} />
            <Route path="onboarding/templates" element={<Templates />} />
            <Route
              path="onboarding/onboarding-templates"
              element={<OnboardingTemplates />}
            />
            <Route
              path="onboarding/edit-onboarding-template"
              element={<EditForms />}
            />
            <Route
              path="onboarding/new-onboarding-template"
              element={<NewOnboardingTemplate />}
            />
            <Route
              path="onboarding/copy-onboarding-templates"
              element={<EditForms />}
            />
            <Route
              path="onboarding/edit-pdf-template"
              element={<DocumentUpload />}
            />
            <Route
              path="onboarding/edit-pdf-form"
              element={<DocumentUpload />}
            />
            <Route path="onboarding/my-team" element={<AllApplications />} />
          </Route>
          <Route path="/editDoc" element={<EditDocument />} />
          <Route path="/preview" element={<Candidate />} />
          <Route
            path="/review/:id/:index"
            element={<CandidateOnboardingForm />}
          />
          <Route path="/verify" element={<RedirectI9Form />} />
          <Route path="/download" element={<DownloadView />} />
        </Route>
        <Route path="/candidate/:id" element={<WelcomePage />} />
        <Route path="/candidate/:id/:tempid" element={<WelcomePage />} />
        <Route path="/otp-verification/:id" element={<OtpVerification />} />
        <Route
          path="/otp-verification/:id/:tempid"
          element={<OtpVerification />}
        />
        <Route path="/thank-you/:id" element={<ThankYou />} />
        <Route
          path="/candidateonboarding/:id"
          element={<CandidateOnboardingForm />}
        />
        <Route
          path="/candidateonboarding/:id/:tempid"
          element={<CandidateOnboardingForm />}
        />
        <Route path="/candidateFillDocument" element={<FillCandidate />} />
      </Routes>
    </AuthProvider>
  );
};

export default Routing;
